import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <g clipPath="url(#success-clip)">
      <circle cx={8} cy={8} r={7} fill="#fff" />
      <path
        fill="#11C871"
        d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm3.265-11.428-4.23 4.21L4.81 6.567l-1.384 1.39 3.606 3.587 5.614-5.585-1.383-1.387.001-.001Z"
      />
    </g>
    <defs>
      <clipPath id="success-clip">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
